import { Link } from "react-router-dom";

import { FaRegMoon } from "react-icons/fa6";
import { FiSun } from "react-icons/fi";

export default function Header(props) {
  return (
    <header>
      <div className="logo">
        <Link to="/" className="logo">
          NICK SEIBERT
        </Link>
      </div>
      <div className="navbar">
        <ul>
          <li>
            <Link to="/links">Links</Link>
          </li>
          <li>
            <Link to="/now">Now</Link>
          </li>
          <div onClick={props.switchColorScheme}>
            <li>{props.darkMode ? <FiSun /> : <FaRegMoon />}</li>
          </div>
        </ul>
      </div>
    </header>
  );
}
